<template>
  <v-form ref="form">
    <v-row>
      <template v-for="(item, key) in form">
        <!-- TEXT -->
        <v-col v-if="item.type === 'text'" cols="12" md="6" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-row>
            <v-col v-if="item.titleText" cols="4" :class="item.titleClass">
              <span class="font-weight-bold" v-html="item.titleText" />
            </v-col>
            <v-col :class="item.valueClass">
              <span v-html="item.valueText" />
            </v-col>
          </v-row>
        </v-col>

        <!-- TEXT-FIELD -->
        <v-col v-if="item.type === 'text-field'" cols="12" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-text-field
            v-model="item.valueText"
            hide-details="auto"
            :ref="key"
            :label="item.titleText"
            :rules="item.required ? [rules.required] : []"
            :required="item.required"
            :hint="item.hint"
            :persistent-hint="item.persistentHint"
            outlined
            dense
          />
        </v-col>

        <!-- DATE-RANGE -->
        <v-col v-if="item.type === 'date-range'" cols="12" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-row v-if="item.canLeaveOneDay" class="pt-2 pb-1">
            <v-col cols="12" class="py-0">
              <v-checkbox
                v-model="item.leaveOneDay"
                class="ma-0"
                label="ลาวันเดียว"
                hide-details="auto"
                @change="$emit('dateRangeChange', key)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col :class="{ 'pb-1': $vuetify.MdAndDown }">
              <v-menu
                v-model="item.beginMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :value="$dateFormatByLang(item.beginDate)"
                    label="ลาตั้งแต่วันที่"
                    hide-details="auto"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="item.beginDate"
                  :locale="$lang === 'Tha' ? 'th' : 'en'"
                  @input="item.beginMenu = false"
                  @change="$emit('dateRangeChange', key)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-if="!item.onlyAllday" cols="12" lg="6" :class="{ 'pt-1': $vuetify.MdAndDown }">
              <v-radio-group
                v-model="item.beginStatus"
                class="ma-0"
                row
                hide-details="auto"
                @change="$emit('dateRangeChange', key)"
              >
                <v-radio label="เต็มวัน" value="ALL" />
                <v-radio label="ครึ่งเช้า" value="AM" />
                <v-radio label="ครึ่งบ่าย" value="PM" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="!(item.beginStatus === 'AM' || item.leaveOneDay)">
            <v-col :class="{ 'pb-1': $vuetify.MdAndDown }">
              <v-menu
                v-model="item.finishMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :value="$dateFormatByLang(item.finishDate)"
                    :disabled="item.beginStatus === 'AM' || item.leaveOneDay"
                    label="ลาถึงวันที่"
                    hide-details="auto"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="item.finishDate"
                  :locale="$lang === 'Tha' ? 'th' : 'en'"
                  :min="
                    $dateFormat(item.beginDate, {
                      addUnit: 'd',
                      addValue: 1
                    })
                  "
                  :disabled="item.beginStatus === 'AM' || item.leaveOneDay"
                  @input="item.finishMenu = false"
                  @change="$emit('dateRangeChange', key)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-if="!item.onlyAllday" cols="12" lg="6" :class="{ 'pt-1': $vuetify.MdAndDown }">
              <v-radio-group
                v-model="item.finishStatus"
                class="ma-0"
                row
                hide-details="auto"
                :disabled="item.beginStatus === 'AM' || item.leaveOneDay"
                @change="$emit('dateRangeChange', key)"
              >
                <v-radio label="เต็มวัน" value="ALL" />
                <v-radio label="ครึ่งเช้า" value="AM" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="!item.isEverydayWorkingday" class="py-3">
            <v-col cols="12" lg="auto" class="py-0">
              <v-checkbox
                v-model="item.checkSaturday"
                class="ma-0"
                label="นับวันเสาร์เป็นวันทำงาน"
                hide-details="auto"
                :disabled="isLeaveDeliver"
                @change="$emit('dateRangeChange', key)"
              />
            </v-col>
            <v-col cols="12" lg="auto" class="py-0">
              <v-checkbox
                v-model="item.checkSunday"
                class="ma-0"
                label="นับวันอาทิตย์เป็นวันทำงาน"
                hide-details="auto"
                :disabled="isLeaveDeliver"
                @change="$emit('dateRangeChange', key)"
              />
            </v-col>
            <v-col cols="12" lg="auto" class="py-0">
              <v-checkbox
                v-model="item.checkHoliday"
                class="ma-0"
                label="นับวันหยุดนักขัตฤกษ์เป็นวันทำงาน"
                hide-details="auto"
                :disabled="isLeaveDeliver"
                @change="$emit('dateRangeChange', key)"
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- CHECKBOX -->
        <v-col v-if="item.type === 'checkbox'" cols="12" md="6" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-checkbox v-model="item.value" :ref="key" class="ma-0" :label="item.label" hide-details="auto" />
        </v-col>

        <!-- FILE-UPLOAD -->
        <v-col v-if="item.type === 'file-upload'" cols="12" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-row>
            <v-col cols="12" class="sub-title2 py-0 px-4 my-0">
              <div class="sub-title2">
                {{ item.hint }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-file-input
                :value="item.file"
                :ref="key"
                :label="item.titleText"
                :rules="item.required ? [rules.required] : []"
                :required="item.required"
                hide-details="auto"
                accept=".jpg, .jpeg, .png, .pdf"
                outlined
                dense
                show-size
                @change="onSelectFile($event, key)"
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- EMPLOYEE-SEARCH -->
        <v-col v-if="item.type === 'emp-search'" cols="12" :class="item.wrapperClass" :key="`${key}-${index}`">
          <leave-search-employee
            :ref="key"
            :selected-employee="item.valueText"
            :selected-employee-title="item.titleText"
            :selected-employee-name="item[`empName${$lang}`]"
            :list="empSearchResultList"
            @search="onSearchEmpApprove"
            @select="onSelectApprover($event, key)"
          />
        </v-col>

        <!-- BUTTON -->
        <v-col v-if="item.type === 'button'" :key="`${key}-${index}`" :cols="!!item.cols ? item.cols : 'auto'">
          <v-btn
            :color="item.color"
            depressed
            :small="item.small"
            :large="item.large"
            @click="$emit(item.name, $refs.form.validate())"
          >
            {{ item.label }}
          </v-btn>
        </v-col>

        <!-- DIVIDER -->
        <v-col v-if="item.type === 'divider'" cols="12" :class="item.wrapperClass" :key="`${key}-${index}`">
          <v-divider />
        </v-col>
      </template>
    </v-row>

    <!-- <v-row align="center">
      <v-col cols="auto">
        <v-btn
          :color="isEditMode ? 'warning darken-1' : 'primary darken-2'"
          depressed
          large
          @click="onSubmitForm()"
        >
          {{ isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล' }}
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="secondary" depressed>
          ยกเลิก
        </v-btn>
      </v-col>
      <v-col></v-col>
    </v-row> -->
  </v-form>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployee';

export default {
  components: {
    LeaveSearchEmployee
  },

  props: {
    form: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      datePicker: {},
      empSearchKeyword: '',
      empSearchResultList: []
    };
  },

  computed: {
    isEditMode() {
      return !!this.$route.params.leaveOrderId;
    },

    rules() {
      return {
        required: v => !!v || 'กรุณากรอกข้อมูลช่องนี้'
      };
    }
  },

  methods: {
    onSelectFile(file, key) {
      // console.log(file)
      // console.log(key)
      const res = {
        name: key
      };
      if (file) {
        const filename = file.name.split('.');
        const fileExt = filename[filename.length - 1].toLowerCase();
        const accepted = ['jpg', 'jpeg', 'png', 'pdf'];

        if (accepted.includes(fileExt)) {
          res.file = file;
        } else {
          res.file = '';
        }
      } else {
        res.file = '';
      }

      this.$emit('fileSelected', res);
    },

    async onSearchEmpApprove(keyword) {
      // console.log('keyword')
      // console.log(keyword)
      this.empSearchKeyword = keyword;
      if (this.empSearchKeyword.length > 2) {
        this.empSearchResultList = await this.apiPostSearchEmployeeByKeyword();
      }
    },

    onSelectApprover(item, key) {
      // console.log(item)
      // console.log(key)
      const res = {
        name: key,
        ID: item.employeeID,
        Tha: item.employeeNameTha,
        Eng: item.employeeNameEng
      };
      this.$emit('empSelected', res);
    },

    onSubmitForm() {
      if (this.$refs.form.validate()) {
        console.log('onSubmitSuccess');
      } else {
        console.log('onSubmitError');
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      const body = {
        Keyword: this.empSearchKeyword
      };
      try {
        const res = await this.$store.dispatch('leave/postSearchEmployeeByKeyword', body);
        return res.data?.data || [];
      } catch (e) {
        console.log(e.response || e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
